import React from 'react';
import styles from './FeaturesTextSection.module.css';

const FeaturesTextSection = ({ features }) => {
  return (
    <div className={styles.featuresList}>
      {features.map((feature, index) => (
        <p key={index} className={styles.featureItem}>
          <span className={styles.featureKey}>{feature.key}</span> {feature.value}
        </p>
      ))}
    </div>
  );
};

export default FeaturesTextSection;